/*
 * Classic Rail carat slider behaviour.
 * The slider is a native <input type="range"> whose value is an INDEX into the
 * carat option values. Hidden radios (rendered by product-variant-options.liquid,
 * tagged data-ffl-rail-index / data-ffl-available) remain the real variant inputs;
 * the slider just checks the matching radio and fires change so Dawn updates the
 * variant. Only available sizes can be landed on; unavailable ticks are struck out.
 */
(function () {
  if (window.__fflCaratRail) return;
  window.__fflCaratRail = true;

  function radiosFor(rail) {
    var scope = rail.closest('.codex-carat-size-picker') || rail.closest('fieldset') || rail.closest('variant-selects') || document;
    return Array.prototype.slice.call(scope.querySelectorAll('input[data-ffl-rail-index]'));
  }
  function caratOf(radio) {
    return String(radio.value || '').replace(/karat/ig, '').replace(/carat/ig, '').replace(/ct/ig, '').trim();
  }
  function isAvail(radio) {
    return radio.getAttribute('data-ffl-available') === 'true' && !radio.disabled;
  }
  function checkedIndex(radios) {
    for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return i; }
    return 0;
  }
  function availIndices(radios) {
    var a = [];
    radios.forEach(function (r, i) { if (isAvail(r)) a.push(i); });
    if (!a.length) radios.forEach(function (_, i) { a.push(i); });
    return a;
  }
  function hasAvail(radios) {
    for (var i = 0; i < radios.length; i++) { if (isAvail(radios[i])) return true; }
    return false;
  }
  function railDisabled(rail) {
    return rail.classList.contains('is-disabled');
  }
  function nearestAvail(radios, idx) {
    var av = availIndices(radios);
    return av.reduce(function (b, c) { return Math.abs(c - idx) < Math.abs(b - idx) ? c : b; }, av[0]);
  }

  /* visual-only update (during drag) — snap to nearest available index, no commit */
  function reflect(rail, idx) {
    var radios = radiosFor(rail);
    if (!radios.length) return idx;
    idx = nearestAvail(radios, idx);
    var last = Math.max(1, radios.length - 1);
    // constant thumb — clean single-row default slider (reduced for a slimmer handle)
    var thumbPx = 16;
    rail.style.setProperty('--thumb', thumbPx + 'px');
    var range = rail.querySelector('[data-ffl-rail-range]');
    if (range) { range.value = idx; range.style.setProperty('--p', (idx / last * 100) + '%'); }
    var num = rail.querySelector('[data-ffl-rail-num]');
    if (num) num.textContent = caratOf(radios[idx]);
    rail.querySelectorAll('.ffl-rail__tick').forEach(function (t) {
      var ti = parseInt(t.getAttribute('data-ffl-rail-index'), 10);
      t.classList.toggle('is-current', ti === idx && !t.classList.contains('is-unavail'));
    });
    return idx;
  }

  /* repaint from whichever radio is currently checked (after load / Shopify re-render) */
  function paint(rail) {
    var radios = radiosFor(rail);
    if (!radios.length) return;
    var disabled = !hasAvail(radios);
    rail.classList.toggle('is-disabled', disabled);
    var idx = checkedIndex(radios);
    reflect(rail, idx);
    var steps = rail.querySelectorAll('[data-ffl-rail-dir]');
    var av = availIndices(radios);
    if (steps[0]) steps[0].disabled = disabled || (idx <= av[0]);
    if (steps[1]) steps[1].disabled = disabled || (idx >= av[av.length - 1]);
  }

  /* commit a selection — check the matching radio and let Dawn update the variant */
  function commit(rail, idx) {
    var radios = radiosFor(rail);
    if (!radios.length || !hasAvail(radios)) return; // nothing purchasable -> not selectable
    idx = nearestAvail(radios, idx);
    var r = radios[idx];
    if (r && !r.checked) {
      r.checked = true;
      r.dispatchEvent(new Event('input', { bubbles: true }));
      r.dispatchEvent(new Event('change', { bubbles: true }));
    }
    paint(rail);
  }

  document.addEventListener('input', function (e) {
    var range = e.target.closest && e.target.closest('[data-ffl-rail-range]');
    if (!range) return;
    var rail = range.closest('[data-ffl-rail]');
    if (rail) reflect(rail, parseInt(range.value, 10));
  });

  document.addEventListener('change', function (e) {
    var range = e.target.closest && e.target.closest('[data-ffl-rail-range]');
    if (range) {
      var rail = range.closest('[data-ffl-rail]');
      if (rail) commit(rail, parseInt(range.value, 10));
      return;
    }
    if (e.target && e.target.matches && e.target.matches('input[data-ffl-rail-index]')) {
      var scope = e.target.closest('variant-selects') || e.target.closest('.product__info-container') || document;
      var rl = scope.querySelector('[data-ffl-rail]');
      if (rl) paint(rl);
    }
  });

  /* ---- Pointer-driven jump & drag layer ----
     Native <input type=range> hit-testing is unreliable inside the glass buy zone
     (real-mouse clicks often miss — same family as the old Popup Cla button dead
     zone; Cod's separate slider suffers it too). This layer trusts pointer
     COORDINATES instead of hit-test targets: any pointerdown whose point falls on
     a rail body jumps/drags that slider, no matter which element got the event. */
  function railBodyAt(x, y) {
    var rails = document.querySelectorAll('[data-ffl-rail]');
    for (var i = 0; i < rails.length; i++) {
      var body = rails[i].querySelector('.ffl-rail__body');
      if (!body) continue;
      var b = body.getBoundingClientRect();
      if (b.width && x >= b.left && x <= b.right && y >= b.top && y <= b.bottom) return rails[i];
    }
    return null;
  }
  function indexFromX(rail, clientX) {
    var range = rail.querySelector('[data-ffl-rail-range]');
    var radios = radiosFor(rail);
    if (!range || !radios.length) return 0;
    var r = range.getBoundingClientRect();
    var last = Math.max(1, radios.length - 1);
    var tw = parseFloat(getComputedStyle(rail).getPropertyValue('--thumb')) || 16;
    var fr = (clientX - r.left - tw / 2) / Math.max(1, r.width - tw); // mirrors the native thumb travel
    fr = Math.min(1, Math.max(0, fr));
    return Math.round(fr * last);
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.button != null && e.button !== 0) return;
    if (window.__fflRailDrag) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.ffl-rail__tick:not(.is-unavail)') || t.closest('[data-ffl-rail-dir]')) return; // ticks/steppers keep their own handlers
    var rail = null;
    var body = t.closest('.ffl-rail__body');
    if (body) rail = body.closest('[data-ffl-rail]');
    if (!rail) {
      // geometry fallback: the event landed on some other element but the POINT is on a rail
      if (t.closest('dialog,[data-codex-qr-modal],.codex-ring-preview-modal')) return;
      rail = railBodyAt(e.clientX, e.clientY);
      if (rail && t.closest('a,button,select,label,[role="option"]') && !rail.contains(t)) return;
    }
    if (!rail || railDisabled(rail)) return;
    var dragging = true;
    window.__fflRailDrag = true;
    reflect(rail, indexFromX(rail, e.clientX));
    var move = function (ev) { if (dragging) reflect(rail, indexFromX(rail, ev.clientX)); };
    var finish = function (ev) {
      if (!dragging) return;
      dragging = false;
      window.__fflRailDrag = false;
      document.removeEventListener('pointermove', move, true);
      document.removeEventListener('pointerup', finish, true);
      document.removeEventListener('pointercancel', finish, true);
      var x = (ev && ev.clientX != null) ? ev.clientX : e.clientX;
      commit(rail, indexFromX(rail, x));
    };
    document.addEventListener('pointermove', move, true);
    document.addEventListener('pointerup', finish, true);
    document.addEventListener('pointercancel', finish, true);
  }, true);

  document.addEventListener('click', function (e) {
    var tick = e.target.closest && e.target.closest('.ffl-rail__tick');
    if (tick && !tick.classList.contains('is-unavail')) {
      var rail = tick.closest('[data-ffl-rail]');
      if (rail && !railDisabled(rail)) commit(rail, parseInt(tick.getAttribute('data-ffl-rail-index'), 10));
      return;
    }
    var step = e.target.closest && e.target.closest('[data-ffl-rail-dir]');
    if (step) {
      var rail2 = step.closest('[data-ffl-rail]');
      if (!rail2) return;
      var radios = radiosFor(rail2);
      var av = availIndices(radios);
      var cur = checkedIndex(radios);
      var pos = av.indexOf(cur);
      if (pos === -1) { cur = nearestAvail(radios, cur); pos = av.indexOf(cur); }
      var next = av[pos + parseInt(step.getAttribute('data-ffl-rail-dir'), 10)];
      if (next != null) commit(rail2, next);
    }
  });

  // Inject the eye icon into the "View on hand" CTA (Aurora Pulse). Idempotent, so it
  // survives Shopify re-rendering the variant picker on a variant change.
  var VOH_EYE = '<svg class="ffl-voh-eye" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>';
  function decorateViewOnHand() {
    document.querySelectorAll('.codex-ring-preview-cta:not([data-ffl-voh])').forEach(function (btn) {
      btn.setAttribute('data-ffl-voh', '1');
      var label = (btn.textContent || 'View on hand').trim() || 'View on hand';
      btn.innerHTML = VOH_EYE + '<span class="ffl-voh-label">' + label + '</span>';
    });
  }

  var raf = false;
  function initAll() {
    raf = false;
    document.querySelectorAll('[data-ffl-rail]').forEach(paint);
    decorateViewOnHand();
  }
  function schedule() {
    if (raf) return;
    raf = true;
    window.requestAnimationFrame(initAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();

  if (window.MutationObserver) {
    var root = document.querySelector('#MainContent') || document.body;
    if (root) new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        // only react to product-area re-renders; chat widgets etc. mutate constantly
        if (muts[i].type === 'childList' && t && t.closest && t.closest('product-info, .product__info-wrapper, variant-selects')) { schedule(); return; }
      }
    }).observe(root, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', initAll);
})();

/* ---------------------------------------------------------------
 * SHOWN line: append "Ct" to the carat (numeric) segment only.
 * The buy-zone "Shown: Metal / Stone / 1" string is built by the
 * shown_variant block's own script; this enhancer post-formats the
 * numeric segment to "1Ct" on every render. It runs on ALL viewports
 * (desktop + mobile) and is idempotent — a value that already carries
 * "ct"/"carat" is left untouched, so it can never produce "1Ct Ct".
 * Scope is limited to [data-codex-shown-value], so the product
 * specification table is unaffected.
 * --------------------------------------------------------------- */
(function () {
  if (window.__fflShownCt) return;
  window.__fflShownCt = true;

  function formatShown(text) {
    return String(text).split(' / ').map(function (part) {
      var t = part.trim();
      // bare number (e.g. "1", "1.5") and NOT already a carat string -> add "Ct"
      if (/^\d+(\.\d+)?$/.test(t)) return t + 'Ct';
      return part;
    }).join(' / ');
  }

  function applyAll() {
    document.querySelectorAll('[data-codex-shown-value]').forEach(function (el) {
      var cur = el.textContent;
      var next = formatShown(cur);
      if (next !== cur) el.textContent = next; // guarded -> no observer feedback loop
    });
  }

  var rafCt = false;
  function scheduleCt() {
    if (rafCt) return;
    rafCt = true;
    window.requestAnimationFrame(function () { rafCt = false; applyAll(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }

  if (window.MutationObserver) {
    var ctRoot = document.querySelector('product-info') || document.querySelector('#MainContent') || document.body;
    if (ctRoot) {
      new MutationObserver(scheduleCt).observe(ctRoot, { childList: true, subtree: true });
    }
  }
  document.addEventListener('shopify:section:load', applyAll);
})();
